import request from '@webtrader/core/request';

export default {
  getAccountDeposit: (signal?: AbortSignal) => request.get<number>('/api/account/v1/deposit', { signal })
};
